var map = {
	"./2025-12-28": "0e69",
	"./2025-12-28.yml": "0e69",
	"./2026-01-04": "f83f",
	"./2026-01-04.yml": "f83f",
	"./active": "5448",
	"./active.yml": "5448",
	"./event-2026-04_asx-card": "99ce",
	"./event-2026-04_asx-card.yml": "99ce",
	"./event-2026-04_brunch-location-change": "404c",
	"./event-2026-04_brunch-location-change.yml": "404c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e577";